<script>
export default {
  name:'new-develop',
  data(){
    return{
      developTitle: '海邻大事记',
      developDescription: '当创新成为时代的延展<br>我们在日新月异的进程中相互印证',
      developAbout: [

        {
          Id: 2,
          year: '2017',
          events: [
            { month: '12月', details: ['通辽海邻成立'] }
          ],
          // position: { x: 300, y: 300 },
          // textAlign: 'right',
          // dotPosition: { x: 500, y: 440 },
        },
        {
          Id: 3,
          year: '2018',
          events: [
            { month: '12月', details: ['内蒙古海邻成立'] }
          ],
          // position: { x: 900, y: 400 },
          // textAlign: 'left',
          // dotPosition: { x: 800, y: 540 },
        },
        {
          Id: 1,
          year: '2014',
          events: [
            { month: '4月', details: ['内蒙古中润成立'] }
          ],
          // position: { x: 730, y: 190 },
          // textAlign: 'right',
          // dotPosition: { x: 800, y: 225 },
        },
        {
          Id: 4,
          year: '2019',
          events: [
            { month: '12月', details: ['绥化海邻成立'] }
          ],
          // position: { x: 520, y: 550 },
          // textAlign: 'right',
          // dotPosition: { x: 666, y: 700 },
        },
        {
          Id: 5,
          year: '2020',
          events: [
            { month: '12月', details: ['中润获得"高新技术企业"认定'] }
          ],
          // position: { x: 800, y: 710 },
          // textAlign: 'left',
          // dotPosition: { x: 680, y: 810 },
        },
        {
          Id: 6,
          year: '2021',
          events: [
            { month: '7月', details: ['通辽梅花入股通辽海邻'] },
            { month: '12月', details: ['通辽海邻获得"高新技术企业"认定'] }
          ],
          // position: { x: 550, y: 830 },
          // textAlign: 'left',
          // dotPosition: { x: 490, y: 885 },
        },
        {
          Id: 7,
          year: '2022',
          events: [

            // { month: '1月', details: ['大庆裕丰项目签约'] },
          ],
          // position: { x: 160, y: 950 },
          // textAlign: 'right',
          // dotPosition: { x: 343, y: 1080 },
        },
        {
          Id: 8,
          year: '2023',
          events: [
            { month: '5月', details: ['龙江海邻项目签约'] },
            { month: '8月', details: ['中润获得"专精特新"中小企业认定'] },
            { month: '12月', details: ['入自治区上市后备库内股交展示板挂牌'] }
          ],
          // position: { x: 250, y: 1130 },
          // textAlign: 'right',
          // dotPosition: { x: 520, y: 1184 },
        },
        {
          Id: 9,
          year: '2024',
          events: [
            { month: '3月', details: ['呼伦海邻成立、与中泰证券签署上市服务协议'] },
            { month: '4月', details: ['内股交天骏板挂牌'] },
            { month: '6月', details: ['通辽海邻获得"专精特新"中小企业认定'] },
            { month: '9月', details: ['大庆海邻成立'] },
            { month: '11月', details: ['海邻蛋白肽公司成立'] }
          ],
          // position: { x: 700, y: 1350 },
          // textAlign: 'right',
          // dotPosition: { x: 795, y: 1400 },
        },
      ],
      scrollPosition: 0,
      isDragging: false,
      startX: 0,
      thumbPosition: 0,
      activePoint: null,
      touchStartX: 0,
      currentTranslateX: 0,
      isTouching: false,
      lastTouchX: 0,
      touchVelocity: 0,
      lastTouchTime: 0,
      yearPositions: [], // 存储每个年份点的位置
      startY: 0,
      lastMouseX: 0,
      lastMouseTime: 0,
      mouseVelocity: 0,
      isMomentumScrolling: false,
      screenWidth: window.innerWidth,
    };
  },
  methods: {
    prevElement() {
      // 获取当前激活点的索引
      const currentIndex = this.years.indexOf(this.activePoint);
      // 如果不是第一个点，则切换到前一个点
      if (currentIndex > 0) {
        const prevYear = this.years[currentIndex - 1];
        this.handleDotClick(prevYear);
      }
    },
    nextElement() {
      // 获取当前激活点的索引
      const currentIndex = this.years.indexOf(this.activePoint);
      // 如果不是最后一个点，则切换到下一个点
      if (currentIndex < this.years.length - 1) {
        const nextYear = this.years[currentIndex + 1];
        this.handleDotClick(nextYear);
      }
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    // 鼠标按下
    handleMouseDown(e) {
      this.isDragging = true;
      this.isMomentumScrolling = false;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.lastMouseX = e.clientX;
      this.lastMouseTime = Date.now();
      this.mouseVelocity = 0;
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    },
    // 鼠标移动
    handleMouseMove(e) {
      if (!this.isDragging) return;

      const currentX = e.clientX;
      const currentY = e.clientY;
      const currentTime = Date.now();
      const timeDiff = currentTime - this.lastMouseTime;

      if (timeDiff > 0) {
        this.mouseVelocity = (this.lastMouseX - currentX) / timeDiff;
      }

      const diffX = this.startX - currentX;
      this.startX = currentX;
      this.startY = currentY;

      // 更新滚动位置
      const timeline = this.$refs.timeline;
      const container = this.$el.querySelector('.background-container');
      const timelineWidth = timeline.offsetWidth;
      const containerWidth = container.offsetWidth;
      const maxScroll = timelineWidth - containerWidth;

      let newPosition = this.scrollPosition + diffX;
      newPosition = Math.max(0, Math.min(newPosition, maxScroll));

      this.scrollPosition = newPosition;
      this.thumbPosition = (newPosition / maxScroll) * 100;

      this.lastMouseX = currentX;
      this.lastMouseTime = currentTime;
    },
    handleTouchMove(e) {
      if (!this.isTouching) return;

      const currentX = e.touches[0].clientX;
      const currentTime = Date.now();
      const timeDiff = currentTime - this.lastTouchTime;

      if (timeDiff > 0) {
        this.touchVelocity = (this.lastTouchX - currentX) / timeDiff;
      }

      const diffX = this.touchStartX - currentX;

      const timeline = this.$refs.timeline;
      const timelineWidth = timeline.offsetWidth;
      const container = this.$el.querySelector('.background-container');
      const containerWidth = container.offsetWidth;
      const maxScroll = timelineWidth - containerWidth;

      let newPosition = this.currentTranslateX + (diffX * 1.5);
      newPosition = Math.max(0, Math.min(newPosition, maxScroll));

      this.scrollPosition = newPosition;
      this.thumbPosition = (newPosition / maxScroll) * 100;

      this.lastTouchX = currentX;
      this.lastTouchTime = currentTime;
    },
    // 鼠标释放
    handleMouseUp() {
      if (!this.isDragging) return;

      this.isDragging = false;
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);

      // 添加惯性滚动
      if (Math.abs(this.mouseVelocity) > 0.5) {
        this.isMomentumScrolling = true;
        this.momentumScroll();
      }
    },
    momentumScroll() {
      if (!this.isMomentumScrolling || Math.abs(this.mouseVelocity) < 0.01) {
        this.isMomentumScrolling = false;
        return;
      }

      const timeline = this.$refs.timeline;
      const timelineWidth = timeline.offsetWidth;
      const containerWidth = this.$el.querySelector('.background-container').offsetWidth;
      const maxScroll = timelineWidth - containerWidth;

      let newPosition = this.scrollPosition + (this.mouseVelocity * 15);
      newPosition = Math.max(0, Math.min(newPosition, maxScroll));

      this.scrollPosition = newPosition;
      this.thumbPosition = (newPosition / maxScroll) * 100;

      this.mouseVelocity *= 0.95; // 减速因子

      requestAnimationFrame(this.momentumScroll);
    },
    startDragging(e) {
      this.isDragging = true;
      this.startX = e.clientX - (this.thumbPosition * this.$el.querySelector('.scroll-track').offsetWidth / 120);
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDragging);
    },
    onDrag(e) {
      if (!this.isDragging) return;

      const scrollTrack = this.$el.querySelector('.scroll-track');
      const trackWidth = scrollTrack.offsetWidth;
      const thumbWidth = this.$refs.scrollThumb.offsetWidth;
      const maxScroll = trackWidth - thumbWidth;

      let newPosition = e.clientX - this.startX;
      newPosition = Math.max(0, Math.min(newPosition, maxScroll));

      this.thumbPosition = (newPosition / maxScroll) * 100;

      const timeline = this.$refs.timeline;
      const timelineWidth = timeline.offsetWidth;
      const containerWidth = this.$el.querySelector('.background-container').offsetWidth;
      const maxTimelineScroll = timelineWidth - containerWidth;

      this.scrollPosition = (this.thumbPosition / 100) * maxTimelineScroll;
    },
    stopDragging() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDragging);
    },
    updateInitialPosition() {
      const timeline = this.$refs.timeline;
      const container = this.$el.querySelector('.background-container');
      if (timeline && container) {
        const timelineWidth = timeline.offsetWidth;
        const containerWidth = container.offsetWidth;
        this.maxScroll = timelineWidth - containerWidth;

        // 计算滑块宽度(固定值，不需要随年份变化)
        const thumbWidth = 8; // 固定8px宽度或根据需求调整
        this.thumbWidth = thumbWidth;
        this.$refs.scrollThumb.style.width = `${thumbWidth}px`;
      }
    },
    // 处理年份点点击
    handleDotClick(year) {
      this.activePoint = year;
      const yearIndex = this.years.indexOf(year);
      if (yearIndex >= 0) {
        const timeline = this.$refs.timeline;
        const container = this.$el.querySelector('.background-container');
        if (timeline && container) {
          const timelineWidth = timeline.offsetWidth;
          const containerWidth = container.offsetWidth;
          const maxScroll = timelineWidth - containerWidth;

          // 使用新的百分比计算方法
          const startYear = parseInt(this.years[0]);
          const endYear = parseInt(this.years[this.years.length - 1]);
          const yearNum = parseInt(year);
          const totalYears = endYear - startYear;

          // 计算目标滚动位置百分比
          const percentage = ((yearNum - startYear) / totalYears) * 100;

          // 转换为实际滚动位置
          let targetScrollPosition = (percentage / 100) * maxScroll;
          targetScrollPosition = Math.max(0, Math.min(targetScrollPosition, maxScroll));

          this.scrollPosition = targetScrollPosition;
          this.thumbPosition = percentage;
        }
      }
    },
    // 更新年份位置信息
    updateYearPositions() {
      const timeline = this.$refs.timeline;
      const container = this.$el.querySelector('.background-container');
      if (!timeline || !container) return;

      const timelineWidth = timeline.offsetWidth;
      const containerWidth = container.offsetWidth;

      // 计算年份跨度
      const startYear = parseInt(this.years[0]);
      const endYear = parseInt(this.years[this.years.length - 1]);
      const totalYears = endYear - startYear;

      this.yearPositions = this.years.map((year, index) => {
        const yearNum = parseInt(year);
        // 计算每个年份点的位置百分比
        const percentage = ((yearNum - startYear) / totalYears) * 100;
        // 计算实际像素位置
        const position = (percentage / 100) * timelineWidth;

        return {
          year,
          position,
          percentage
        };
      });
    },
    handleTouchStart(e) {
      this.isTouching = true;
      this.touchStartX = e.touches[0].clientX;
      this.lastTouchX = this.touchStartX;
      this.currentTranslateX = this.scrollPosition;
      this.lastTouchTime = Date.now();
      this.touchVelocity = 0;

      // 获取触摸点的坐标
      const touch = e.touches[0];
      const container = this.$el.querySelector('.background-container');
      const containerRect = container.getBoundingClientRect();
      const touchX = touch.clientX - containerRect.left + this.scrollPosition;

      // 检查是否触摸到了时间点
      const timeline = this.$refs.timeline;
      const timelinePoints = timeline.querySelectorAll('.timeline-point');

      timelinePoints.forEach((point, index) => {
        const pointRect = point.getBoundingClientRect();
        const pointCenterX = pointRect.left - containerRect.left + this.scrollPosition;

        // 检查触摸点是否在时间点的范围内（考虑点的宽度和点击区域）
        if (Math.abs(touchX - pointCenterX) < 30) {
          this.activePoint = this.years[index];
        }
      });
    },
    findClosestYear(scrollPosition) {
      if (!this.yearPositions.length) return null;

      const containerWidth = this.$el.querySelector('.background-container').offsetWidth;
      const centerPosition = scrollPosition + (containerWidth / 2);

      let closestYear = this.yearPositions[0];
      let minDistance = Math.abs(closestYear.position - centerPosition);

      this.yearPositions.forEach(yearPos => {
        const distance = Math.abs(yearPos.position - centerPosition);
        if (distance < minDistance) {
          minDistance = distance;
          closestYear = yearPos;
        }
      });

      return closestYear.year;
    },
    handleTouchEnd() {
      if (!this.isTouching) return;

      this.isTouching = false;

      // 添加惯性滚动
      if (Math.abs(this.touchVelocity) > 0.5) {
        const timeline = this.$refs.timeline;
        const timelineWidth = timeline.offsetWidth;
        const containerWidth = this.$el.querySelector('.background-container').offsetWidth;
        const maxScroll = timelineWidth - containerWidth;

        const momentum = () => {
          if (Math.abs(this.touchVelocity) < 0.01) return;

          let newPosition = this.scrollPosition + (this.touchVelocity * 15);
          newPosition = Math.max(0, Math.min(newPosition, maxScroll));

          this.scrollPosition = newPosition;
          this.thumbPosition = (newPosition / maxScroll) * 100;

          this.touchVelocity *= 0.95; // 减速因子

          requestAnimationFrame(momentum);
        };

        requestAnimationFrame(momentum);
      }
    },
    // 平滑滚动到指定位置
    smoothScrollTo(targetPosition) {
      const startPosition = this.scrollPosition;
      const distance = targetPosition - startPosition;
      const duration = 500; // 动画持续时间(ms)
      const startTime = performance.now();

      const animateScroll = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);

        // 使用缓动函数使滚动更平滑
        const easeProgress = this.easeOutQuad(progress);
        this.scrollPosition = startPosition + (distance * easeProgress);

        // 更新滚动条位置
        const timeline = this.$refs.timeline;
        const container = this.$el.querySelector('.background-container');
        if (timeline && container) {
          const timelineWidth = timeline.offsetWidth;
          const containerWidth = container.offsetWidth;
          const maxScroll = timelineWidth - containerWidth;
          this.thumbPosition = (this.scrollPosition / maxScroll) * 100;
        }

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    },
    // 缓动函数 - 二次缓出
    easeOutQuad(t) {
      return t * (2 - t);
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.updateYearPositions();
    window.addEventListener('resize', this.updateYearPositions);

    this.$nextTick(() => {
      // Set activePoint to the maximum year value
      this.activePoint = Math.max(...this.years.map(year => parseInt(year))).toString();

      // 使用新的计算方法设置初始位置
      const startYear = parseInt(this.years[0]);
      const endYear = parseInt(this.years[this.years.length - 1]);
      const totalYears = endYear - startYear;
      this.thumbPosition = 100; // 最新年份对应100%
      const timeline = this.$refs.timeline;
      const container = this.$el.querySelector('.background-container');
      if (timeline && container) {
        const timelineWidth = timeline.offsetWidth;
        const containerWidth = container.offsetWidth;
        this.scrollPosition = timelineWidth - containerWidth;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', this.updateYearPositions);
    window.removeEventListener('resize', () => {
      this.updateInitialPosition();
      this.updateYearPositions();
    });

    const timeline = this.$refs.timeline;
    if (timeline) {
      timeline.removeEventListener('touchstart', this.handleTouchStart);
      timeline.removeEventListener('touchmove', this.handleTouchMove);
      timeline.removeEventListener('touchend', this.handleTouchEnd);
      timeline.removeEventListener('mousedown', this.handleMouseDown);
    }
  },
  computed: {
    years() {
      return this.sortedDevelopAbout.map(item => item.year);
    },
    timelineWidth() {
      const baseWidth = this.screenWidth > 768 ? 200 : 133.3;
      return `${baseWidth * this.developAbout.length}px`;
    },
    sortedDevelopAbout() {
      return [...this.developAbout].sort((a, b) => a.Id - b.Id);
    },
    canGoPrev() {
      const currentIndex = this.years.indexOf(this.activePoint);
      return currentIndex > 0;
    },
    canGoNext() {
      const currentIndex = this.years.indexOf(this.activePoint);
      return currentIndex < this.years.length - 1;
    }
  },
};
</script>

<template>
  <div class="new-develop">
    <h2 class="title">{{ developTitle }}</h2>
    <div class="controlImg">
      <img
        src="../../assets/home/pre.png"
        @click="prevElement"
        class="controlImgL"
        :class="{ 'disabled': !canGoPrev }"
      >
      <img
        src="../../assets/home/next.png"
        @click="nextElement"
        class="controlImgR"
        :class="{ 'disabled': !canGoNext }"
      >
    </div>
    <div class="developDescription">
      <div class="background-container"
           @touchstart.prevent="handleTouchStart"
           @touchmove.prevent="handleTouchMove"
           @touchend.prevent="handleTouchEnd">


        <div class="background-image"></div>
        <div class="timeline"
             ref="timeline"
             :style="{ transform: `translate(-${scrollPosition}px, -50%)`,width: timelineWidth  }">
          <div v-for="(year, index) in years"
               :key="year"
               class="timeline-point"
               @click="handleDotClick(year)">
            <div class="dot-container">
              <div v-if="activePoint === year" class="dot-outer"></div>
              <div v-if="activePoint === year" class="dot-middle"></div>
              <div class="dot" :class="{ 'active': activePoint === year }"></div>
            </div>
            <div class="year-label" :class="{ 'active': activePoint === year }">{{ year }}</div>
            <div v-if="index < years.length - 1" class="connector-line"></div>
          </div>
        </div>
        <div class="Pc-move"
             @mousedown.prevent="handleMouseDown"
             @mousemove.prevent="handleMouseMove"
             @mouseup.prevent="handleMouseUp"
        ></div>

        <div class="scroll-container">
          <div class="scroll-track">
            <div class="scroll-thumb"
                 ref="scrollThumb"
                 @mousedown="startDragging"
                 :style="{ left: `${thumbPosition}%`, width: `${thumbWidth}%` }">
            </div>
          </div>
        </div>
      </div>
      <!-- 事件显示容器 -->
      <div v-if="activePoint" class="events-container">
        <div class="events-row">
          <template v-for="(item, index) in sortedDevelopAbout">
            <div v-if="item.year === activePoint ||
                     (index > sortedDevelopAbout.findIndex(i => i.year === activePoint) &&
                      index <= sortedDevelopAbout.findIndex(i => i.year === activePoint) + 0)"
                 :key="item.year"
                 class="event-column">
              <div class="event-year" :class="{ 'active-year': item.year === activePoint }">{{ item.year }}</div>
              <div v-for="event in item.events" :key="event.month" class="event-content" >
                <div class="event-month">{{ event.month }}</div>
                <div v-for="(detail, detailIndex) in event.details"
                     :key="detailIndex"
                     class="event-detail">
                  {{ detail }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="less" scoped>
@import "@/assets/fontsize/aboutHaiLin.less";  /* ✅ 正确引入变量定义 */

.Pc-move{
  width: 100%;
  height: 70px;
  position: absolute;
  top: 70%;
}
.controlImg{
  width: 100%;
  height: 1px;
  position: relative;
}
.controlImgL{
  width:calc( 2.5vw + 20px );
  height:calc( 2.5vw + 20px );
  max-width: 60px;
  max-height: 60px;
  position: absolute;
  left: -2%;
  top: 150px;
  z-index: 1;
  filter: brightness(0) saturate(100%) invert(57%) sepia(4%) saturate(263%) hue-rotate(175deg)
}
.controlImgR{
  width:calc( 2.5vw + 20px );
  height:calc( 2.5vw + 20px );
  max-width: 60px;
  max-height: 60px;
  position: absolute;
  left: 98%;
  top: 150px;
  z-index: 1;
  filter: brightness(0) saturate(100%) invert(57%) sepia(4%) saturate(263%) hue-rotate(175deg)
}
/* 修改容器样式 */
.background-container {
  width: 80vw;
  height: 35vh;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid #eee;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  -webkit-overflow-scrolling: touch;
  font-family: 'SourceHanSansCN', sans-serif;
  /* 隐藏滚动条但保持功能 */
  /*  scrollbar-width: none; /* Firefox */
  /*  -ms-overflow-style: none; /* IE and Edge */
}

/* 隐藏 Webkit 浏览器的滚动条 */
.background-container::-webkit-scrollbar {
  display: none;
}

.background-image {
  width: 100%;
  height: 100%;
  background-image: url('@/assets/history/develop.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  opacity: 1;
}

/* 时间轴容器 */
.timeline {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  width: 1800px;
  justify-content: space-between;
  transition: transform 0.3s ease;
  padding: 0 100px;
  gap: 90px;
  touch-action: pan-x;
  user-select: none;
  -webkit-user-select: none;
}

/* 时间点容器 */
.timeline-point {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  z-index: 2;
}

/* 修改点容器样式 */
.dot-container {
  position: relative;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 原始点样式 */
.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #e6e6e6;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

/* 中层浅蓝点 */
.dot-middle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: rgba(0, 160, 250);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  animation: fadeIn 0.3s ease;
}

/* 外层深蓝点 */
.dot-outer {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(0, 160, 250, 0.5);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  animation: fadeIn 0.3s ease;
}

/* 年份标签 */
.year-label {
  font-size: 21px;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(0, 0, 0);
  font-weight: bold;
  line-height: 1.2;
  position: absolute;
  top: -34px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;

}

/* 连接线样式 */
.connector-line {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px; /* 与 gap 相同 */
  height: 2px;
  background-color: #e6e6e6;
  transform: translateY(-50%);
  z-index: 1;
}

/* 保留原有的其他样式 */
.new-develop {

  margin: 0 auto;
  font-family: 'SourceHanSansCN', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ... 其他原有样式 ... */

/* 标题样式 */
.title {
  text-align: center;
  margin-bottom: 4vw;
  margin-top: 4vw;
  font-size: @title-fontsize;
  font-family: "Source Han Sans CN";
  color: rgb(26, 26, 26);
  font-weight:@title-font-weight;
  line-height: 0.626;
}
@media (max-width: 768px) {
  .title {
    text-align: center;
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 28px;
    font-family: "Source Han Sans CN";
    color: rgb(26, 26, 26);
    line-height: 0.626;
  }
}
/* 响应式样式 */
@media (max-width: 1800px) {
  .timeline {
    gap: 90px;
  }
  .connector-line {
    width: 200px;
  }
}

@media (max-width: 1200px) {
  .timeline {
    gap: 90px;
  }
  .connector-line {
    width: 200px;
  }
}

@media (max-width: 768px) {
  .background-container {
    height: 30vh;
    width:300px;
    min-width: 250px;
    position: relative;
    overflow: hidden;
    cursor: grab;
    touch-action: pan-x;
    -webkit-tap-highlight-color: transparent;
  }

  .background-container:active {
    cursor: grabbing;
  }

  .background-image {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    opacity: 1;
    top: 0;
    pointer-events: none;
  }

  .timeline {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    gap: 90px;
    width: 1200px;
    transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    pointer-events: auto;
    padding: 20px 100px;
  }

  .timeline-point {
    cursor: pointer;
    touch-action: none; /* 防止触摸事件的默认行为 */
  }

  .dot-container {
    width: 15px; /* 增加点击区域 */
    height: 15px;
    padding: 0;
    background-color: transparent;
    position: relative;
  }

  .dot {
    width: 15px;
    height: 15px;
    background-color: #e6e6e6;
    transition: all 0.3s ease;
  }

  .dot.active {
    background-color: rgb(0, 160, 250);
    transform: scale(1.2); /* 激活时稍微放大 */
  }

  .dot-middle {
    width: 15px;
    height: 15px;
    background-color: rgba(0, 160, 250);
  }

  .dot-outer {
    width: 30px;
    height: 30px;
    background-color: rgba(0, 160, 250, 0.5);
  }

  .year-label {
    font-size: 21px;
    font-weight: 500;
    transition: all 0.3s ease;
    opacity: 0.6;
  }

  .year-label.active {
    opacity: 1;
    color: #00a0fa;
    transform: scale(1.1); /* 激活时稍微放大 */
  }

  .connector-line {
    width: 125px;
    height: 4px;
    transition: all 0.3s ease;
  }

  .timeline-point.active + .timeline-point .connector-line {
    background-color: #00a0fa;
  }

  /* 隐藏滚动条
  .scroll-container {
    display: none;
  } */
}

/* 添加滚动条样式 */
.scroll-container {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 10px;
  z-index: 3; /* 确保滚动条在最上层 */
}

.scroll-track {
  width: 100%;
  height: 8px;
  background-color: #f0f0f0;
  position: relative;
  border-radius: 1.5px;
}

.scroll-thumb {
  position: absolute;
  width: 25%;
  height: 100%;
  background-color: #00a0fa;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.scroll-thumb:hover {
  background-color: #0078d7;
}

/* 确保时间轴两端的点位置正确 */
.timeline-point:first-child {
  margin-left: 0;
}

.timeline-point:last-child {
  margin-right: 0;
}

/* 移除最后一个点的连接线 */
.timeline-point:last-child .connector-line {
  display: none;
}

/* 添加激活状态的点样式 */
.dot.active {
  background-color: rgb(0, 160, 250);
}

/* 添加淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 事件容器样式 */
.events-container {
  width: 80%;
  margin: 30px auto 0;
  padding: 20px;
}

.events-row {
  display: flex;
  justify-content: flex-start;

  gap: 40px;
}

.event-column {
  flex: 1;
  min-width: 0;
}

.event-year {
  font-size: 21px;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(102, 102, 102);
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  transition: color 0.3s ease;
  position: relative;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.event-year::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 20vw;
  height: 2px;
  background-color: #d8d8d8;
  transition: background-color 0.3s ease;
}

.active-year {
  color: rgb(0, 160, 250);
}

.active-year::after {
  background-color: rgb(0, 160, 250);
}

.event-content {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.event-month {
  font-size: 18px;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(77, 77, 77);
  line-height: 1.974;
}

.event-detail {
  font-size: 18px;
  font-family: "Alimama FangYuanTi VF";
  /*color: rgb(77, 77, 77);*/
  line-height: 1.974;
  margin-bottom: 5px;
  flex: 1;
  font-family: 'SourceHanSansCN', sans-serif;
  font-weight: 100;
}

/* 响应式样式 */
@media (max-width: 768px) {
  .controlImg{
    width: calc(5vw + 50px + 100%);
  }
  .controlImgL, .controlImgR {
    top:calc(60px + 10vw);
  }
  .controlImgL{
   left:0;
  }
  .controlImgR {
    left:calc(100% - 2.5vw - 20px);
  }
  .events-container {
    width: 90%;
    padding:0;
  }

  .events-row {
    flex-direction: column;
    gap: 20px;
  }

  .event-column {
    width: 100%;
  }

  .event-year {
    font-size: 21px;
    padding-bottom: 8px;
    margin-bottom: 12px;
  }

  .event-year::after {
    width: 100%;
    height: 3px;
  }

  .event-content {
    gap: 8px;
  }

  .event-month {
    font-size: 18px;
    min-width: 32px;
  }

  .event-detail {
    font-size: 18px;
  }
}

.controlImgL, .controlImgR {
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.controlImgL.disabled, .controlImgR.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.controlImgL:not(.disabled):hover, .controlImgR:not(.disabled):hover {
  opacity: 0.8;
}
@media (max-width: 380px) {
  .background-container {
    width: 280px;
  }
}
</style>
